module.exports = __webpack_public_path__ + "db75773d1aeebcc4af17ff691673a0db.png";